export default function parseTransactionId(transactionId) {
  if (!transactionId) return null;

  const parts = transactionId.split('-');
  if (parts.length < 3) return null;

  const publisherId = parts.at(-1);
  const campaignId = parts.at(-2);
  const clickId = parts.slice(0, -2).join('-');

  if (!clickId || !campaignId || !publisherId) return null;
  if (!/^\d+$/.test(campaignId) || !/^\d+$/.test(publisherId)) return null;

  return {
    clickId,
    campaignId,
    publisherId,
  };
}
